module.exports = "/_next/static/images/regulatory-compliance-info-11034bb0f4a6256439a102b89f0c8341.webp";